import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import React, { useMemo } from 'react';
import { getLocale } from 'umi';
import classNames from 'classnames';
import { BaseComponentProps } from '../../types/commom';
import './index.scss';

interface Iprops extends BaseComponentProps {
  config: {
    title: string;
    titleCn: string;
  };
}

// 页面右侧操作栏标题组件
const OperationTitle = (props: Iprops) => {
  const { config, className, style } = props || {};
  const isEN = getLocale() === LANGUAGE_EN;
  const { title, titleCn } = config || {};

  const content = useMemo(() => getName(isEN, title, titleCn), [title, titleCn, isEN]);

  return (
    <div className={classNames('dbb-operation-title-container', className)} style={style}>
      {content}
    </div>
  );
};

export default OperationTitle;
